import styled from 'styled-components';

import { remify } from '#/service/utils';

export const Message = styled.p`
  margin: 0;
`;

export const ButtonContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-top: ${remify(24)};
  margin-inline: auto;
  gap: ${remify(8)};
`;
